import React from "react"
import { Box, useTheme, BoxProps } from "@chakra-ui/react"
import { useThemeOptions } from "../hooks/useThemeOptions"

export interface MainProps extends BoxProps {
  children?: React.ReactNode
  props?: any
}

const Main = React.forwardRef(({ children, props }: MainProps, ref: any) => {
  const { variables } = useTheme()
  const { usePageTransitions } = useThemeOptions()

  return !usePageTransitions ? (
    <Box
      as="main"
      marginTop={variables.siteMarginTop}
      paddingLeft={variables.sideMenuWidth}
      ref={ref}
      {...props}
    >
      {children}
    </Box>
  ) : (
    <>children</>
  )
})

export default Main
